import { Component, OnInit, OnDestroy, HostListener, AfterViewInit } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import 'hammerjs';
import * as $ from 'jquery';
import * as slick from 'ngx-slick';
import { ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import * as downloadjs from 'downloadjs';

@Component({
  selector: 'app-investors',
  templateUrl: './investors.component.html',
  styleUrls: ['./investors.component.scss'],
})

export class InvestorsComponent implements OnInit, OnDestroy, AfterViewInit {

  hasSlide1 = false;
  hasSlide2 = false;
  isMobile: boolean;
  private fragment: string;
  pageSize = 6;
  p = 1;
  totalItems = 12;
  startHeight: any;
  expandHeight: any;

  financials: any;
  financialsDistance: any;
  corp: any;
  corpDistance: any;
  press: any;
  pressDistance: any;
  present: any;
  presentDistance: any;
  stockUp = true;

  ticker: 'GOOGL';

  articles = [
    {
      id: "Exclusive-Distribution",
      title: "Mimi’s Rock Corp. Signs Exclusive Agreement for Distribution of Brands in People’s Republic of China",
      date: "TORONTO, January 8, 2020",
      source: "Mimi's Rock Corp.",
      body: "(TORONTO, January 8, 2020) Mimi's Rock Corp. ('Mimi's Rock' or the 'Company') (TSXV:MIMI) an online dietary supplement and wellness company operating the Dr. Tobias, All Natural Advice and Maritime Naturals brands, is pleased to announce the Company has entered into an exclusive agreement with WestGoods Inc. (the “Buyer”) for the sale of our brands in The People’s Republic of China.",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=5232476706882038&qm_symbol=MIMI"
    },
    {
      id: "Lennox-By-Dr-Tobias",
      title: "Mimi’s Rock Corp. Announces Lennox by Dr Tobias Branded Nutritional Supplements now available on Amazon.com",
      date: "TORONTO, December 16, 2019",
      source: "Mimi's Rock Corp.",
      body: "(Toronto: December 16, 2019) Mimi's Rock Corp. ('Mimi's Rock' or the 'Company') (TSXV:MIMI), is pleased to announce a new line of nutritional supplements, launched under the brand 'LENNOX by Dr Tobias', is now available in the United States on Amazon.com, and on drtobias.com",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=6356796268611535&qm_symbol=MIMI"
    },
    {
      id: "All-Natural-Acquisition",
      title: "Mimi's Rock Corp. Closes Acquisition of All Natural Advice and Maritime Naturals, Restructures Senior Credit Facilities",
      date: "TORONTO, December 13, 2019",
      source: "Mimi's Rock Corp.",
      body: "(Toronto: December 13, 2019) Mimi's Rock Corp. ('Mimi's Rock' or the 'Company') (TSXV:MIMI) is pleased to announce the successful completion of its previously-announced acquisition of All Natural Advice Ltd. ('All Natural') and Maritime Naturals Ltd. ('Maritime Naturals') by way of a share purchase transaction.",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=7071388848803464&qm_symbol=MIMI"
    },
    {
      id: "Q3-2019-Results",
      title: "Mimi’s Rock Corp. Announces Q3 2019 Results",
      date: "TORONTO, November 28, 2019",
      source: "Mimi's Rock Corp.",
      body: "Mimi’s Rock Corp. (TSXV:MIMI) “The Company”, an online dietary supplement and wellness company operating the Dr. Tobias brand, today announced its financial results for the quarter ended September 30, 2019.",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=6320781859552130&qm_symbol=MIMI"
    },
    {
      id: "Launch-Canadian-Sales",
      title: "Mimi's Rock Corp. Announces Launch of Canadian Sales of Dr. Tobias Products",
      date: "TORONTO, November 13, 2019",
      source: "Canada Newswire",
      body: "Mimi's Rock Corp. ('MR' or 'the Company') (TSXV: MIMI), an online dietary supplement and wellness business, is pleased to announce the launch of its Dr. Tobias line of dietary supplements in Canada.",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=8840358068749182&qm_symbol=MIMI"
    },
    {
      id: "Definitive-Agreement-to-Launch",
      title: "Mimi's Rock Crop. & Lennox Lewis Sign Definitive Agreement to Launch Branded Nutritional Supplements",
      date: "TORONTO, Septempber 24, 2019",
      source: "Canada Newswire",
      body: "Mimi's Rock Corp. (TSXV:MIMI) 'The Company', an online dietary supplement and wellness company operating the Dr. Tobias brand, is pleased to announce, further to the joint venture  announcement of July 8, 2019, the execution of a definitive agreement with three-time world heavyweight champion Lennox Lewis to develop and commercialize a new line of branded nutritional supplements.",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=7326391845456983&qm_symbol=MIMI"
    },
    {
      id: 'Aquire-Top-Selling-Brands',
      title: "Mimi's Rock Corp. to Acquire Top Selling Beauty Brands All Natural Advice and Maritime Naturals",
      date: 'TORONTO, September 5, 2019',
      source: 'Canada NewsWire',
      body: "Mimi's Rock Corp. ('Mimi's Rock' or 'the Company') (TSXV: MIMI), an online dietary supplement and wellness business, is pleased to announce it has entered into binding agreements to acquire two additional businesses, namely All Natural Advice Ltd. ('All Natural') and Maritime Naturals Ltd. ('Maritime Naturals').",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=4697200906708783&qm_symbol=MIMI"
    },
    {
      id: 'Q2-Results-Announcement',
      title: "Mimi's Rock Corp. Announces Q2 Results",
      date: 'TORONTO, August 29, 2019',
      source: 'Canada NewsWire',
      body: "Mimi’s Rock Corp. (TSXV:MIMI) 'The Company', an online dietary supplement and wellness company operating the Dr. Tobias brand, today announced its financial results for the quarter ended June 30, 2019.",
      emailBody: "https://mimisrock.com/#/article/Q2-Results-Announcement"
    },
    {
      id: 'Branded-Nutritional-Supplements',
      title: "Mimi's Rock Corp. Enters JV With Undisputed Boxing Champion Lennox Lewis For Branded Nutritional Supplements",
      date: 'TORONTO, July 8, 2019',
      source: 'Canada NewsWire',
      body: "TORONTO , July 8, 2019 /CNW/ - Mimi's Rock Corp. (MIMI.V) ('The Company'), an online dietary supplement and wellness company operating the Dr. Tobias brand, is pleased to announce that it has entered into a Joint Venture Agreement with three-time world heavyweight champion Lennox Lewis to develop and commercialize a new line of branded nutritional supplements.",
      emailBody: "https://finance.yahoo.com/news/mimis-rock-corp-enters-jv-120000337.html?.tsrc=applewf",
    },
    {
      id: 'Joint-Venture',
      title: "Avivagen and Mimi's Rock Announce Joint Venture for the Companion Animal Market",
      date: 'TORONTO and OTTAWA, June 13, 2019',
      source: 'Canada NewsWire',
      body: "TORONTO and OTTAWA, June 13, 2019 /CNW/ - Mimi's Rock Corp. (TSXV:MIMI or 'Mimi's Rock'), an online dietary supplement and wellness company operating under the Dr. Tobias brand and with significant sales on the Amazon.com platform, and Avivagen Inc. (TSXV:VIV) ('Avivagen' or the 'Corporation'), owner of the intellectual property protected OxC-beta™ technology that supports the optimal health of companion animals, are pleased to announce a Joint Venture agreement focused on the online sale of nutritional supplements for cats and dogs. Under the terms of the agreement, Avivagen will supply its products that include its proprietary OxC-beta™ technology and Mimi's Rock will market and sell the product through its state of the art e-commerce platform and online global channels. This joint venture will be the exclusive channel through which Avivagen sells nutritional supplements for cats and dogs online. All sales will be conducted through a newly formed corporation jointly owned by Avivagen and Mimi's Rock. The profits will be shared equally between the two companies.",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=5027583731851353&qm_symbol=MIMI"
    },
    {
      id: 'New-ECommerce-Website',
      title: "Mimi's Rock Corp. Launches New E-Commerce Website",
      date: 'TORONTO, June 6, 2019',
      source: 'Canada NewsWire',
      body: "TORONTO, June 6, 2019 /CNW/ - Mimi's Rock Corp. (TSXV:MIMI) 'The Company', an online dietary supplement and wellness company operating under the Dr. Tobias brand,  is pleased to announce that it has launched its new e-commerce platform, developed by Commerce Dynamics.",
      emailBody: "https://web.tmxmoney.com/article.php?newsid=6395179726848787&qm_symbol=MIMI",
    },
  ];

  teamMembers = [
    {
      id: 0,
      pId: 'p0',
      imgId: 'img0',
      textId: 'txt0',
      name: 'DAVID KOHLER',
      role: 'Director, Chief Executive Officer',
      image: "url('./assets/images/team/david1200x800.png')",
      isLeft: false,
      isOpen: false,
      description: "Mr. Kohler has significant experience in the OTC consumer health business through his 22 years of industry experience. Most recently, Mr. Kohler was General Manager of the consumer products division of Apotex Inc., a multinational generic pharmaceutical company. Mr. Kohler has a Bachelor's degree from Wilfrid Laurier University and an MBA from Queen's University.",
      description2: '',
      description3:  ''
    },
    {
      id: 1,
      pId: 'p1',
      imgId: 'img1',
      textId: 'txt1',
      name: 'TELFER HANSON',
      role: 'Director, Executive Chairman',
      image: "url('./assets/images/team/telfer1200x800.png')",
      isLeft: true,
      isOpen: false,
      description: 'Mr. Hanson is an experienced capital markets professional having served 22 years in senior investment banking positions, including covering healthcare and medical technology companies. Most recently, Mr. Hanson was responsible for the sale of Medic Holdings Corp. to Agility Health Inc., a public healthcare services company. Prior to that, Mr. Hanson held senior investment banking positions at several independent brokerage firms.',
      description2: '',
      description3:  ''
    },
    {
      id: 2,
      pId: 'p2',
      imgId: 'img2',
      textId: 'txt2',
      name: 'NORMAN BETTS',
      role: 'Board Member',
      image: "url('./assets/images/team/norman_betts.png')",
      isLeft: false,
      isOpen: false,
      description: "Mr. Betts has extensive experience in financing, accounting and audit in the public sector, having served on the board of several public companies. Mr. Betts served as the Minister of Finance in New Brunswick from 1999 to 2001 and as and Minister of Business in New Brunswick from 2001 to 2003. He currently sits on the boards of New Brunswick Power Corp. and Bank of Canada. Mr. Betts has a Bachelor’s of Business Administration degree from the University of New Brunswick and a PhD in Accounting and Finance from Queen's University.",
      description2: '',
      description3:  ''
    },
    {
      id: 3,
      pId: 'p3',
      imgId: 'img3',
      textId: 'txt3',
      name: 'DAVID GRANDIN',
      role: 'Board Member',
      image: "url('./assets/images/team/dave1200x800.png')",
      isLeft: true,
      isOpen: false,
      description: "Mr. Grandin has over 20 years of experience starting companies and building teams in the high-tech sector. He combines a strong entrepreneurial skill set with an extensive background in software and integrated system development, digital media solutions and sports-related technology. Mr. Grandin has a Bachelor's of Science in Electrical Engineering and Computer Science from the University of Wisconsin and an MBA in High Technology from Northeastern University.",
      description2: '',
      description3:  ''
    },
    {
      id: 4,
      pId: 'p4',
      imgId: 'img4',
      textId: 'txt4',
      name: 'BRYAN PEARSON',
      role: 'Board Member',
      image: "url('./assets/images/team/bryan1200x800.png')",
      isLeft: false,
      isOpen: false,
      description: 'Mr. Pearson has three decades of experience within the loyalty and marketing sector. An internationally recognized expert, author, and speaker on customer loyalty and marketing, Mr. Pearson is the current President and CEO of LoyaltyOne, a subsidiary of Alliance Data (NYSE: ADS). A pioneer in loyalty strategies and measured marketing, Pearson and the LoyaltyOne team leverage consumer insights to influence over $160 billion in annual retail sales by working with their clients to create relevant communications and enhanced shopper experiences.',
      description2: '',
      description3:  ''
    }
  ];

  videos = [
    {
      link: '',
      name: 'Name of Video Lorem Innum Datum',
      length: '4:25'
    },
    {
      link: '',
      name: 'Name of Video Lorem Innum Datum',
      length: '4:25'
    },
    {
      link: '',
      name: 'Name of Video Lorem Innum Datum',
      length: '4:25'
    },
    {
      link: '',
      name: 'Name of Video Lorem Innum Datum',
      length: '4:25'
    },
    {
      link: '',
      name: 'Name of Video Lorem Innum Datum',
      length: '4:25'
    },
  ];

  presentations = [
    {
      path: './assets/presentations/Investor-deck-sept24-2019.pdf',
      name: 'Corporate Overview',
      description: "Mimi's Rock is a diverse, global group of health and business professionals dedicated to offering a wide selection of wellness products that we are proud to stand behind.  Mimi's Rock was founded to build a significant growth platform in the consumer healthcare space.  The acquisition of Dr. Tobias provides Mimi's Rock with an initial, large consumer health product portfolio with over 30 branded products in the vitamin, health supplements, and wellness categoies.  We are committed to exceed our customers' expectations, while aiding them in improving their overall wellness.  We want to make it wasy for them to achieve what they believe to be possible.",
      thumbnail: './assets/presentations/corp-overview-2019-02/new-thumbnail-corp-overview.jpg'
    },
    {
      path: './assets/presentations/Executive-summary-july-22-2019.pdf',
      name: 'Executive Summary',
      description: "",
      thumbnail: './assets/presentations/corp-overview-2019-02/new-thumbnail-corp-overview.jpg'
    }
  ];

  pdfs = [
    {
      id: 0,
      title: 'Governance Committee Charter',
      subtitle: 'May 27, 2019',
      filepath: './assets/presentations/MIMI_-_Governance_Committee_Charter_[2019May27].pdf'
    },
    {
      id: 1,
      title: 'Compensation Committee Charter',
      subtitle: 'May 27, 2019',
      filepath: './assets/presentations/MIMI_-_Compensation_Committee_Charter_[2019May27].pdf'
    },
    {
      id: 2,
      title: 'Audit & Risk Committee Charter',
      subtitle: 'May 27, 2019',
      filepath: './assets/presentations/MIMI_-_Audit_&_Risk_Committee_Charter_[2019May27].pdf'
    },
    {
      id: 3,
      title: 'Acquisitions Committee Charter',
      subtitle: 'May 27, 2019',
      filepath: './assets/presentations/MIMI_-_Acquisitions_Committee_Charter_[2019May27].pdf'
    },
  ];

  newPdfs = [
    {
      id: 0,
      filepath: './assets/presentations/articles-of-incorporation/MRI_-_Articles_of_Incorporation_and_Amendments.pdf',
      title: 'Articles of Incorporation, Amalgamation, and Continuation',
      subtitle: ''
    },
    {
      id: 1,
      filepath: './assets/presentations/by-law-no-1/MRI_-_By-law_No._1.pdf',
      title: 'By-Laws',
      subtitle: '',
    },
    // {
    //   id: 2,
    //   filepath: './assets/presentations/by-law-no-1/MRI_-_By-law_No._1.pdf',
    //   title: 'Chairman of the Board and Lead Director Position Description',
    //   subtitle: '',
    // },
    {
      id: 3,
      // filepath: './assets/presentations/articles-of-incorporation/MRI_-_Articles_of_Incorporation_and_Amendments.pdf',
      filepath: './assets/presentations/MIMI-BoardMandate.pdf',
      title: 'Board Mandate',
      subtitle: ''
    },
  ];

  // --> ON RESIZE LOGIC
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth >= 720) {
      this.isMobile = false;
      this.startHeight = '400px';
      this.expandHeight = '650px';
      this.teamMembers.forEach((member) => {
        member.isOpen = false;
        $('#' + member.id).css('height', this.startHeight);
        $('#' + member.imgId).css({'min-width': '350px'});
        $('#' + member.imgId).css({'width': '25%'});
        $('#' + member.imgId).css({'height': '100%'});
        $('#' + member.imgId).css({'margin': '0'});
      });
    } else if (window.innerWidth >= 450 && window.innerWidth <= 719) {
      this.isMobile = true;
      this.startHeight = '300px';
      this.expandHeight = '550px';
      this.teamMembers.forEach((member) => {
        member.isOpen = false;
        $('#' + member.id).css('height', this.startHeight);
        $('#' + member.imgId).css({'min-width': '50%'});
        $('#' + member.imgId).css({'width': '25%'});
        $('#' + member.imgId).css({'height': '100%'});
        $('#' + member.imgId).css({'margin': '0'});
      });
    } else {
      this.isMobile = true;
      this.startHeight = '250px';
      this.expandHeight = '500px';
      this.teamMembers.forEach((member) => {
        member.isOpen = false;
        $('#' + member.id).css('height', this.startHeight);
        $('#' + member.imgId).css({'min-width': '50%'});
        $('#' + member.imgId).css({'width': '25%'});
        $('#' + member.imgId).css({'height': '100%'});
        $('#' + member.imgId).css({'margin': '0'});
      });
    }

  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const $window = $(window);
    this.financials = document.getElementById('financials');
    this.financialsDistance = this.financials.offsetTop - 85;
    this.corp = document.getElementById('corporate');
    this.corpDistance = this.corp.offsetTop - 120;
    this.press = document.getElementById('press');
    this.pressDistance = this.press.offsetTop - 85;
    this.present = document.getElementById('presentations');
    this.presentDistance = this.present.offsetTop - 85;

    if ($window.scrollTop() > this.financialsDistance && $window.scrollTop() < this.corpDistance) {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').addClass('is-bold');
    } else if ($window.scrollTop() > this.corpDistance && $window.scrollTop() < this.pressDistance) {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').addClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    } else if ($window.scrollTop() > this.pressDistance && $window.scrollTop() < this.presentDistance) {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').addClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    } else if ($window.scrollTop() > this.presentDistance) {
      $('#toPresentations').addClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    } else {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    }

  }

  constructor(public angulartics2: Angulartics2,
              private route: ActivatedRoute,
              private http: Http) {

  }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'page-view-main'
      });
      console.log(this.angulartics2);
    }
  }

  ngAfterViewInit(): void {
    const $window = $(window);
    try {
      try {
        if (this.fragment === 'title') {
          $('html,body').scrollTop(0);
        } else {
          $('html, body').animate({scrollTop: $('#' + this.fragment).offset().top - 80}, {duration: 'medium', complete: function() {
            $('#under-bar').css({'opacity': 1});
            $('#under-bar').animate({'margin-left': '343px'});
            if (window.innerWidth <= 1194) {
              const mobileAbout = document.getElementById('mobile-about');
              mobileAbout.classList.remove('opac');
              const mobileBrands = document.getElementById('mobile-brands');
              mobileBrands.classList.remove('opac');
              const mobileTeam = document.getElementById('mobile-team');
              mobileTeam.classList.remove('opac');
              const mobileInvestors = document.getElementById('mobile-investors');
              mobileInvestors.classList.add('opac');
              const mobileContact = document.getElementById('mobile-contact');
              mobileContact.classList.remove('opac');
            }
          }});

        }
      } catch (e) {
        // console.log(e);
      }
    } catch (e) {
      // console.log(e);
    }
    if (window.innerWidth >= 720) {
      this.isMobile = false;
      this.startHeight = '400px';
      this.expandHeight = '650px';
    } else if (window.innerWidth >= 450 && window.innerWidth <= 719) {
      this.isMobile = true;
      this.startHeight = '300px';
      this.expandHeight = '550px';
    } else {
      this.isMobile = true;
      this.startHeight = '250px';
      this.expandHeight = '500px';
    }
    if (window.innerWidth >= 1195) {
      $('#about-link').addClass('grey-text');
      $('#brands-link').addClass('grey-text');
      $('#team-link').addClass('grey-text');
      $('#investors-link').addClass('grey-text');
      $('#contact-link').addClass('grey-text');
    }
    if ($window.scrollTop() > this.financialsDistance && $window.scrollTop() < this.corpDistance) {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').addClass('is-bold');
    } else if ($window.scrollTop() > this.corpDistance && $window.scrollTop() < this.pressDistance) {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').addClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    } else if ($window.scrollTop() > this.pressDistance && $window.scrollTop() < this.presentDistance) {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').addClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    } else if ($window.scrollTop() > this.presentDistance) {
      $('#toPresentations').addClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    } else {
      $('#toPresentations').removeClass('is-bold');
      $('#toPress').removeClass('is-bold');
      $('#toCorp').removeClass('is-bold');
      $('#toFinancials').removeClass('is-bold');
    }
    const teamImages = document.querySelectorAll('.image-container');
    for (let i = 0; i < this.teamMembers.length; i++) {
      $(teamImages[i]).css('background-image', this.teamMembers[i].image);
    }
  }

  ngOnDestroy() {

  }

  toPresentations() {
    $('html, body').animate({scrollTop: $('#presentations').offset().top}, 'medium');
    $('#toPresentations').css('font-weight', 'bold');
    $('#toPress').css('font-weight', 100);
    $('#toCorp').css('font-weight', 100);
    $('#toFinancials').css('font-weight', 100);
  }

  toPress() {
    $('html, body').animate({scrollTop: $('#press').offset().top}, 'medium');
    $('#toPresentations').css('font-weight', 100);
    $('#toPress').css('font-weight', 900);
    $('#toCorp').css('font-weight', 100);
    $('#toFinancials').css('font-weight', 100);
  }

  toCorp() {
    $('html, body').animate({scrollTop: $('#corporate').offset().top - 80}, 'medium');
    $('#toPresentations').css('font-weight', 100);
    $('#toPress').css('font-weight', 100);
    $('#toCorp').css('font-weight', 900);
    $('#toFinancials').css('font-weight', 100);
  }

  toFinancials() {
    $('html, body').animate({scrollTop: $('#financials').offset().top - 80}, 'medium');
    $('#toPresentations').css('font-weight', 100);
    $('#toPress').css('font-weight', 100);
    $('#toCorp').css('font-weight', 100);
    $('#toFinancials').css('font-weight', 900);
  }

  downloadPdf() {
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'download-corp-gov-pdf'
      });
      console.log(this.angulartics2);
    }
  }

  downloadPresentation() {
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'download-presentation-pdf'
      });
      console.log(this.angulartics2);
    }
  }

  openPresentation(url: string) {
    window.open(url);
  }

  openRow(id, pId, imgId, txtId) {
    if (this.teamMembers[id].isOpen === false) {
      this.teamMembers[id].isOpen = true;
      this.animateRow(id, pId, imgId, txtId);
     //  this.expandRow(id, pId, imgId, txtId);
    }
  }

  closeRow(id, pId, imgId, txtId, event) {
    this.teamMembers[id].isOpen = false;
    this.animateRow(id, pId, imgId, txtId);
    event.stopPropagation();
  }

  expandRow(id, pId, imgId, txtId) {
    const rowId = '#' + id;
    const imageId = '#' + imgId;
    const profileId = '#' + pId;
    const textId = '#'  + txtId;

    $(imageId).delay(60).animate({'width': 'toggle'}, {duration: 'fast', complete: function() {
      // $(rowId).animate({'height': this.expandHeight}, {duration: 'fast', complete: function() {
      //   $(imageId).css('width', '45%');
      // }});
    }});

  }

  animateRow(id, pId, imgId, txtId) {

    const rowId = '#' + id;
    const imageId = '#' + imgId;
    const profileId = '#' + pId;
    const textId = '#'  + txtId;

    if (this.teamMembers[id].isOpen) {
      if (window.innerWidth <= 719 && window.innerWidth >= 450) {
        $(imageId).css('width', '45%');
        $(imageId).css({'min-width': '45%'});
        $(imageId).css({'height': '300px'});
        $(imageId).css({'margin': '2.5%'});
        $(rowId).animate({'height': this.expandHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 1}, {duration: 'slow'});
          $(textId).animate({'opacity': 1}, {duration: 'slow'});
        }});
      } else if (window.innerWidth <= 449) {
        $(imageId).css('width', '45%');
        $(imageId).css({'min-width': '45%'});
        $(imageId).css({'height': '250px'});
        $(imageId).css({'margin': '2.5%'});
        $(rowId).animate({'height': this.expandHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 1}, {duration: 'slow'});
          $(textId).animate({'opacity': 1}, {duration: 'slow'});
        }});
      } else {
        $(imageId).animate({'width': '45%'});
        $(rowId).animate({'height': this.expandHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 1}, {duration: 'slow'});
          $(textId).animate({'opacity': 1}, {duration: 'slow'});
        }});
      }
    } else {
      if (window.innerWidth <= 719) {
        $(imageId).css({'min-width': '50%'});
        $(imageId).css('width', '25%');
        $(imageId).css({'height': '100%'});
        $(imageId).css({'margin': '0'});
        $(rowId).animate({'height': this.startHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 0}, {duration: 'slow'});
          $(textId).animate({'opacity': 0}, {duration: 'slow'});
        }});
      } else {
        $(imageId).animate({'width': '25%'});
        $(rowId).animate({'height': this.startHeight}, {duration: 'medium', complete: function() {
          $(profileId).animate({'opacity': 0}, {duration: 'slow'});
          $(textId).animate({'opacity': 0}, {duration: 'slow'});
        }});
      }
    }
  }

}
